import * as React from 'react';
import { FormikProps } from 'formik';
import { trackShow } from './tracking';
import * as styles from './DealRentTrap.css';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ApplicationContext } from './../ApplicationContext';
import { DealRentTrapOptions } from './DealRentTrapOptions';
import { TAnalyticsOfferStatus } from '../../types/analytics';

export interface IDealRentTrapProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
  dealRentCost: string;
  isMobile: boolean;
  analyticsOfferStatus: TAnalyticsOfferStatus;
  goToNextStep(): void;
  applyDealRent(): void;
}

export interface IFormValues {
  isTermsAccepted: boolean;
}

export type TDealRentTrapOfertaFormikProps = IDealRentTrapProps & FormikProps<IFormValues>;

export class DealRentTrap extends React.Component<TDealRentTrapOfertaFormikProps> {
  public static contextType = ApplicationContext;

  public componentDidMount() {
    trackShow(this.props.analyticsOfferStatus);
  }

  public render() {
    const { isMobile } = this.props;

    return (
      <div className={styles[isMobile ? 'mobile-wrap' : 'wrap']}>
        <div className={styles['title']}>
          Выберите как вы хотите сдавать квартиру?
        </div>
        <DealRentTrapOptions
          {...this.props}
        />
      </div>
    );
  }
}
